import { Divider, IconButton, Tooltip } from '@mui/joy';
import { ArrowsOutSimple, X } from '@phosphor-icons/react';
import { FormattedMessage, useIntl } from 'react-intl';

import MainActions, {
  MainActionData,
} from '~/components/customer/report/reportActions/mainActions';
import { Button } from '~/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogTitle,
  DialogClose,
} from '~/components/ui/dialog';

export default function ExpandedCaseAction({
  reportActionData,
  setReportActionData,
  disabledFlag,
  triggerUpdate,
  isLoading,
}: MainActionData & {
  triggerUpdate: () => void;
  isLoading: boolean;
}) {
  const intl = useIntl();

  return (
    <Dialog>
      <DialogTrigger>
        <Tooltip
          title={intl.formatMessage({
            defaultMessage: 'View Case Action as Full Screen',
          })}
        >
          <IconButton>
            <ArrowsOutSimple className='text-white hover:text-black' />
          </IconButton>
        </Tooltip>
      </DialogTrigger>
      <DialogContent size='5xl' className='flex flex-col gap-4'>
        <div className='flex justify-between w-full'>
          <DialogTitle className='!bg-blue flex'>
            <FormattedMessage defaultMessage='Actions' />
          </DialogTitle>
          <DialogClose>
            <IconButton size='sm'>
              <X />
            </IconButton>
          </DialogClose>
        </div>
        <Divider />
        <MainActions
          reportActionData={reportActionData}
          setReportActionData={setReportActionData}
          disabledFlag={disabledFlag}
        />
        <Button size='lg' color='primary' onClick={triggerUpdate} loading={isLoading}>
          <FormattedMessage defaultMessage='Update' />
        </Button>
      </DialogContent>
    </Dialog>
  );
}
